import React from 'react';
import HeaderSeven from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer/FooterThree';
import HouseJobMain from './HouseJobMain';

const HouseJob = () => {
  return (
    <>
      <HeaderSeven />
      <HouseJobMain />
      <Footer />
    </>
  );
};

export default HouseJob;
